import { jsx as _jsx } from "react/jsx-runtime";
const SIcon = ({ Icon, size = 24, color = "currentColor", className, ...props }) => {
    return _jsx(Icon, { fontSize: size, fill: color, color: color, className: className, ...props });
};
export default SIcon;
